import { Link } from 'react-router-dom';
import MovieCard from '@/components/feature/MovieCard';
import type { Movie } from '@/mocks/movies';

interface RankingSectionProps {
  title: string;
  movies: Movie[];
  viewAllLink?: string;
}

export default function RankingSection({ title, movies, viewAllLink }: RankingSectionProps) {
  return (
    <section className="w-full px-4 md:px-6 py-8 md:py-10">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-end justify-between mb-5 md:mb-6">
          <div className="flex items-center gap-3">
            <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-500/15">
              <i className="ri-fire-line text-base text-accent-400"></i>
            </span>
            <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-100">
              {title}
            </h3>
          </div>
          {viewAllLink && (
            <Link
              to={viewAllLink}
              className="flex items-center gap-1 text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
            >
              查看全部
              <i className="ri-arrow-right-line text-xs"></i>
            </Link>
          )}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {movies.map((movie, index) => (
            <MovieCard
              key={movie.id}
              movie={movie}
              variant="ranking"
              rank={index + 1}
            />
          ))}
        </div>
      </div>
    </section>
  );
}